module.exports = __webpack_public_path__ + "static/media/sim_feature.26cb003d.png";